import { render, staticRenderFns } from "./Releases.vue?vue&type=template&id=b8837322&scoped=true"
import script from "./Releases.vue?vue&type=script&lang=js"
export * from "./Releases.vue?vue&type=script&lang=js"
import style0 from "./Releases.vue?vue&type=style&index=0&id=b8837322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8837322",
  null
  
)

export default component.exports